import React, { useEffect, useState } from "react";
import * as core from "@material-ui/core";
import * as icons from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import { v4 as uuidv4 } from "uuid";
import * as YUP from "yup";
import axios from "axios";

const AddressList = (props) => {
  const { touched, errors, handleBlur, handleChange } = props;
  const { t } = useTranslation();
  const [disablePrimaryCheckBox, setDisablePrimaryCheckBox] = useState(false);
  const initialValues = {
    id: uuidv4(),
    label: "",
    countryCode: "",
    city: "",
    postCode: "",
    detail: "",
    isPrimary: false,
  };

  const validationSchema = YUP.object({});

  const onSubmit = (values, { resetForm }) => {
    props.setFieldValue("addressList", [...props.values.addressList,values]);
    resetForm();
  };

  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const getResult = async (metadataGroup) => {
    const result = await axios.get(
      `http://localhost:5001/api/Management/get_metadata_values?metadataGroup=${metadataGroup}`
    );
    var data = [{ metadataCode: "", metadataValue: "Select" }];

    result.data.data.map((rc) => {
      data.push({
        metadataCode: rc.metadataCode,
        metadataValue: rc.metadataValue,
      });
    });

    if (metadataGroup === "Country") {
      setCountryList(data);
    } else {
      setCityList(data);
    }
  };


  useEffect(() => {
    if (props.values.addressList && props.values.addressList.length>0) {
      props.values.addressList.filter(row=> row.isPrimary===true).length>0? setDisablePrimaryCheckBox(true): setDisablePrimaryCheckBox(false);
   }
    else{
      setDisablePrimaryCheckBox(false);
    }
    const getResult2 = async () => {
      await getResult("Country");
    };

    getResult2();
  }, [props.values.addressList]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values,
        }) => (
          <core.Container>
            <core.Card style={{ marginBottom: 20 }}>
              <core.CardHeader title={t("address.entry")} />
              <core.Divider />
              <core.CardContent>
                <core.Grid container spacing={6}>
                  <core.Grid item md={6} xs={12}>
                    <core.TextField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      label={t("address.label")}
                      name="label"
                      error={Boolean(touched.label && errors.label)}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.label}
                    />
                  </core.Grid>

                  <core.Grid item md={6} xs={12}>
                    <core.TextField
                      fullWidth
                      label={t("address.countryCode")}
                      name="countryCode"
                      select
                      SelectProps={{ native: true }}
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(touched.countryCode && errors.countryCode)}
                      onBlur={handleBlur}
                      onChange={(event) => {
                        handleChange(event);
                        getResult(event.target.value + "Cities");
                      }}
                      value={values.countryCode}
                    >
                      {countryList?.map((option) => (
                        <option
                          key={option.metadataCode}
                          value={option.metadataCode}
                        >
                          {option.metadataValue}
                        </option>
                      ))}
                    </core.TextField>
                  </core.Grid>

                  <core.Grid item md={6} xs={12}>
                    <core.TextField
                      fullWidth
                      label={t("address.city")}
                      name="city"
                      select
                      SelectProps={{ native: true }}
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(touched.city && errors.city)}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.city}
                    >
                      {cityList?.map((option) => (
                        <option
                          key={option.metadataCode}
                          value={option.metadataCode}
                        >
                          {option.metadataValue}
                        </option>
                      ))}
                    </core.TextField>
                  </core.Grid>

                  <core.Grid item md={6} xs={12}>
                    <core.TextField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      label={t("address.postCode")}
                      name="postCode"
                      error={Boolean(touched.postCode && errors.postCode)}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.postCode}
                    />
                  </core.Grid>

                  <core.Grid item md={6} xs={12}>
                    <core.TextField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      label={t("address.detail")}
                      name="detail"
                      error={Boolean(touched.detail && errors.detail)}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.detail}
                    />
                  </core.Grid>

                  <core.Grid item md={6} xs={12}>
                  <core.FormControlLabel
                    control={
                      <core.Checkbox 
                      name="isPrimary"
                      disabled={disablePrimaryCheckBox}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      checked={values.isPrimary}
                      value={values.isPrimary}
                    />
                    }
                    label={t("address.isPrimary")}
                  />
                   
                  </core.Grid>

                  <core.Grid item md={12} xs={12}>
                    <core.Box display="flex" justifyContent="center">
                      <core.Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<icons.AddBox />}
                        onClick={handleSubmit}
                      >
                        Add
                      </core.Button>
                    </core.Box>
                  </core.Grid>
                </core.Grid>
              </core.CardContent>
            </core.Card>

            <core.Card>
              <core.CardHeader
                title={t("pages.WorkerDemanderProfile.AddressList.stepname")}
              />
              <core.Divider />
              <core.CardContent>
                <core.Grid container spacing={6}>
                  <core.Grid item md={12} xs={12}>
                    <core.TableContainer component={core.Paper}>
                      <core.Table aria-label="simple table">
                        <core.TableHead>
                          <core.TableRow>
                            <core.TableCell>
                              {t("address.label")}
                            </core.TableCell>
                            <core.TableCell>
                              {t("address.countryCode")}
                            </core.TableCell>
                            <core.TableCell>{t("address.city")}</core.TableCell>
                            <core.TableCell>
                              {t("address.postCode")}
                            </core.TableCell>
                            <core.TableCell>
                              {t("address.detail")}
                            </core.TableCell>
                            <core.TableCell>
                              {t("address.isPrimary")}
                            </core.TableCell>
                          </core.TableRow>
                        </core.TableHead>

                        <core.TableBody>
                          {props.values.addressList.map((row) => (
                            <core.TableRow key={row.id}>
                              <core.TableCell>{row.label}</core.TableCell>
                              <core.TableCell>{row.countryCode}</core.TableCell>
                              <core.TableCell>{row.city}</core.TableCell>
                              <core.TableCell>{row.postCode}</core.TableCell>
                              <core.TableCell>{row.detail}</core.TableCell>
                              <core.TableCell> 
                                  <core.Checkbox
                                        fullWidth
                                        checked={row.isPrimary}
                                        />
                             </core.TableCell>
                             <core.TableCell> 
                              <core.IconButton aria-label="delete" onClick={() => { 
                                 props.setFieldValue("addressList",props.values.addressList.filter((xx) => xx.id !== row.id));}}>
                                   <icons.Delete/>
                              </core.IconButton>
                            </core.TableCell>
                            </core.TableRow>
                          ))}
                        </core.TableBody>
                      </core.Table>
                    </core.TableContainer>
                  </core.Grid>
                </core.Grid>
              </core.CardContent>

              {/* Master state
                        <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
            </core.Card>
          </core.Container>
        )}
      </Formik>
    </div>
  );
};

export default AddressList;
